import { render, staticRenderFns } from "./Translates.vue?vue&type=template&id=36b625c0&scoped=true&"
import script from "./Translates.vue?vue&type=script&lang=js&"
export * from "./Translates.vue?vue&type=script&lang=js&"
import style0 from "./Translates.vue?vue&type=style&index=0&id=36b625c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b625c0",
  null
  
)

export default component.exports